import { XMLParser } from 'fast-xml-parser';

export function parseEventPlanIndicators(svgContent: string) {
	try {
		const xmlParser = new XMLParser({
			ignoreAttributes: false,
		});
		const content = xmlParser.parse(svgContent);
		const groups = Array.isArray(content.svg.g) ? content.svg.g : [content.svg.g];

		const indicators = [] as any[];
		for (const group of groups) {
			const indicatorGroup = {
				id: group['@_id'],
				nameFa: group['@_data-name-fa'],
				nameEn: group['@_data-name-en'],

				matchingRadius: parseFloat(group.circle['@_r']),

				items: [] as any[],
			};

			const items = Array.isArray(group.rect) ? group.rect : [group.rect];
			for (const item of items) {
				const x = parseFloat(item['@_x']);
				const y = parseFloat(item['@_y']);
				const s = parseFloat(item['@_width']);

				indicatorGroup.items.push({
					id: item['@_id'],
					x: x + s / 2,
					y: y + s / 2,
				});
			}

			indicators.push(indicatorGroup);
		}

		return indicators;
	} catch (error) {
		console.error('Invalid Indicators Model');
		return null;
	}
}

export function findNearestIndicators(indicators: any[], coords: any): string[] {
	const out = [] as string[];
	if (!indicators?.length) {
		return [];
	}

	for (const indicator of indicators) {
		const radius = indicator.matchingRadius;

		let nearestDistance = +Infinity;
		let nearestItem: any;
		for (const item of indicator.items) {
			if (
				item.x >= coords.x - radius &&
				item.x <= coords.x + radius &&
				item.y >= coords.y - radius &&
				item.y <= coords.y + radius
			) {
				const distance = Math.hypot(item.x - coords.x, item.y - coords.y);
				if (distance < nearestDistance) {
					nearestDistance = distance;
					nearestItem = item;
				}
			}
		}

		if (nearestItem) {
			out.push(`${indicator.nameFa} ${nearestItem.id}`);
		}
	}

	return out;
}
